export const UPDATE_APP = 'UPDATE_APP';
export const SET_PRODUCT_CATEGORY = 'SET_PRODUCT_CATEGORY';
export const SET_SHAPES = 'SET_SHAPES';
export const SET_I18N = 'SET_I18N';
export const SET_TEXT_SHAPES = 'SET_TEXT_SHAPES';
export const SET_CONVERTER_URI = 'SET_CONVERTER_URI';
